import api from '@/apis/di/budgetKindItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBudgetSubKindItemComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetSubKindItemComboboxLoadData = (payload, row, column, custom) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let ors1 = [{ Field: 'is_parent', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: ors1 },
    ]; // 2 Là khoản
    payload.sort = 'budget_kind_item_code';
    payload.filter = extendFilter(payload.filter, extend);

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const budgetSubKindItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã khoản',
        dataField: 'budget_kind_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên khoản',
        dataField: 'budget_kind_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_kind_item_code',
    valueField: 'budget_kind_item_code',
    queryMode: 'remote',
    quickSearch: 'BudgetKindItemQuickSearch',
    quickSearchParam: {
      isFilter: true,
      titleSearch: 'Tìm nhanh khoản',
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    dropdownWidth: 600,
    comboboxLoadData: onBudgetSubKindItemComboboxLoadData,
    modelValueField: 'budget_sub_kind_item_code',
  };

  // Sự kiện load combo trên grid
  return {
    budgetSubKindItemComboConfig,
    onBudgetSubKindItemComboboxLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
  };
};
